module.exports = __webpack_public_path__ + "media/images/rhs_bn01-27184375fde2dcf12b49fe4723b5a241.png";